function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import { GridMouseHandler } from '@deephaven/grid';
/**
 * Trigger quick filters and advanced filters
 */
class IrisGridFilterMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
  }
  onDown(gridPoint) {
    var y = gridPoint.y,
      column = gridPoint.column,
      row = gridPoint.row;
    if (column !== null && row === null) {
      var _this$irisGrid$state = this.irisGrid.state,
        isFilterBarShown = _this$irisGrid$state.isFilterBarShown,
        metrics = _this$irisGrid$state.metrics;
      if (!metrics) throw new Error('Metrics not set');
      var columnHeaderMaxDepth = metrics.columnHeaderMaxDepth;
      var theme = this.irisGrid.getTheme();
      if (isFilterBarShown && theme.columnHeaderHeight != null && theme.filterBarHeight != null && y > theme.columnHeaderHeight * columnHeaderMaxDepth && y <= theme.columnHeaderHeight * columnHeaderMaxDepth + theme.filterBarHeight) {
        this.irisGrid.focusFilterBar(column);
        return true;
      }
    }
    return false;
  }
  onMove(gridPoint) {
    var y = gridPoint.y,
      column = gridPoint.column;
    var _this$irisGrid$state2 = this.irisGrid.state,
      isFilterBarShown = _this$irisGrid$state2.isFilterBarShown,
      hoverAdvancedFilter = _this$irisGrid$state2.hoverAdvancedFilter,
      metrics = _this$irisGrid$state2.metrics;
    if (!metrics) throw new Error('Metrics not set');
    var columnHeaderMaxDepth = metrics.columnHeaderMaxDepth;
    var theme = this.irisGrid.getTheme();
    var newHoverAdvancedFilter = null;
    if (isFilterBarShown && theme.columnHeaderHeight != null && theme.filterBarHeight != null && column !== null && y >= theme.columnHeaderHeight * columnHeaderMaxDepth && y <= theme.columnHeaderHeight * columnHeaderMaxDepth + theme.filterBarHeight) {
      newHoverAdvancedFilter = column;
    }
    if (newHoverAdvancedFilter !== hoverAdvancedFilter) {
      this.irisGrid.setState({
        hoverAdvancedFilter: newHoverAdvancedFilter
      });
    }
    return false;
  }
  onLeave(gridPoint) {
    var column = gridPoint.column;
    var hoverAdvancedFilter = this.irisGrid.state.hoverAdvancedFilter;
    if (hoverAdvancedFilter !== null && column !== hoverAdvancedFilter) {
      this.irisGrid.setState({
        hoverAdvancedFilter: null
      });
    }
    return false;
  }
}
export default IrisGridFilterMouseHandler;
//# sourceMappingURL=IrisGridFilterMouseHandler.js.map